// =================================================================
// Engine: Amikacin cross-nomogram conversion (PSD §4.2.6 / TODO Task 3.5)
// =================================================================
import { AMIKACIN_CONVERSION_FACTOR_DEFAULT } from './constants';
/**
 * Convert an amikacin level to a gent/tobra-equivalent for nomogram lookup.
 * conversionFactor default 3, configurable 2–6 (open Q2 — default 3).
 */
export function convertAmikacinLevel(levelMg, conversionFactor = AMIKACIN_CONVERSION_FACTOR_DEFAULT) {
    const factor = conversionFactor >= 2 && conversionFactor <= 6 ? conversionFactor : AMIKACIN_CONVERSION_FACTOR_DEFAULT;
    return levelMg / factor;
}
/** Detect augmented renal clearance — recommend high-clearance q12h pathway. */
export function detectHighClearance(kelPerHr) {
    const halfLifeHr = kelPerHr > 0 ? Math.log(2) / kelPerHr : 0;
    return { halfLifeHr, recommendQ12h: halfLifeHr < 2 };
}
//# sourceMappingURL=amikacinConversion.js.map